import { generateParams } from '@/utils/helpers';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';

import instance from '../instance';

const errorMapper = new ErrorMapper();
const resource = '/imports';

export default {
  getContactsImport: async function ({ id, token, params = [] }) {
    try {
      let paramsString = generateParams(params);
      return await instance.get(`${resource}/contacts/${ id }${ paramsString }`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      throw errorMapper.mapToCodeModel(error);
    }
  },
  getPropertiesImport: async function ({ id, token, params = [] }) {
    try {
      let paramsString = generateParams(params);
      return await instance.get(`${resource}/properties/${ id }${ paramsString }`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      throw errorMapper.mapToCodeModel(error);
    }
  },
  getNotesImport: async function ({ id, token, params = [] }) {
    try {
      let paramsString = generateParams(params);
      return await instance.get(`${resource}/notes/${ id }${ paramsString }`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      throw errorMapper.mapToCodeModel(error);
    }
  },
  importContacts: async function ({ token, payload }) {
    try {
      return await instance.post(`${resource}/contacts`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      throw errorMapper.mapToCodeModel(error);
    }
  },
  importProperties: async function ({ token, payload }) {
    try {
      return await instance.post(`${resource}/properties`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      throw errorMapper.mapToCodeModel(error);
    }
  },
  importNotes: async function ({ token, payload }) {
    try {
      return await instance.post(`${resource}/notes`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      throw errorMapper.mapToCodeModel(error);
    }
  },
  importDeals: async function ({ token, payload }) {
    try {
      return await instance.post(`${resource}/deals`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
    } catch (error) {
      throw errorMapper.mapToCodeModel(error);
    }
  },
  processContacts: async function ({ token, id, payload }) {
    try {
      return await instance.post(`${resource}/contacts/${id}/process`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      throw errorMapper.mapToCodeModel(error);
    }
  },
  processProperties: async function ({ token, id, payload }) {
    try {
      return await instance.post(`${resource}/properties/${id}/process`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      throw errorMapper.mapToCodeModel(error);
    }
  },
  processNotes: async function ({ token, id, payload }) {
    try {
      return await instance.post(`${resource}/notes/${id}/process`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      throw errorMapper.mapToCodeModel(error);
    }
  },
  processDeals: async function ({ token, id, payload }) {
    try {
      return await instance.post(`${resource}/${id}/process-deals`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      throw errorMapper.mapToCodeModel(error);
    }
  },
  getReapps: async function ({ token, reportType }) {
    try {
      return await instance.get(`${resource}/reapps?reportType=${reportType}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      throw errorMapper.mapToCodeModel(error);
    }
  }
};
